/**
 * Sectors data configuration
 * This should be replaced with actual data from API/CMS
 */
import sector1 from "@assets/images/about-us/sector-1.png";
import sector2 from "@assets/images/about-us/sector-2.png";
import sector3 from "@assets/images/about-us/sector-3.png";
import sector4 from "@assets/images/about-us/sector-4.png";

export const sectorsData = [
  {
    name: "ourSectors.steel.title",
    image: sector1,
    color: "bg-steel",
    description: "ourSectors.steel.description",
    hex: "#F43400",
    to: "fabricated-sector",
  },
  {
    name: "ourSectors.hvac.title",
    image: sector2,
    color: "bg-aqua-blue",
    description: "ourSectors.hvac.description",
    hex: "#00C2E1",
    to: "air-conditioning-sector",
  },
  {
    name: "ourSectors.insulation.title",
    image: sector3,
    color: "bg-insulation",
    description: "ourSectors.insulation.description",
    hex: "#9531B3",
    to: "insulation-sector",
  },
  {
    name: "ourSectors.construction.title",
    image: sector4,
    color: "bg-construction",
    description: "ourSectors.construction.description",
    hex: "#FFB624",
    to: "construction-sector",
  },
];

/**
 * Type definitions for sector data
 */
export interface SectorData {
  name: string;
  image: string;
  color: string;
  description: string;
  hex: string;
  to: string;
}